/* MAZI — Terra homepage.

   Hier stond een "reis door het verhaal": een klik op de knop bovenaan
   scrolde in een lange animatie door de hele film naar de koopkaart. Dat
   is er op 2026-08-18 uitgehaald op verzoek van de klant: de knop gaat nu
   gewoon naar de productpagina. Weggehaald in plaats van uitgezet, zodat
   niemand hem per ongeluk weer aanzet door [data-film-seek] terug te
   plaatsen. */

/* Elke filmclip pas tonen zodra hij een frame heeft.
   Zonder dit zie je bij het laden een wit vlak waar de poster hoort te
   staan: de video is dan al zichtbaar maar nog leeg. De stylesheet houdt
   .terra-film__video op opacity 0 tot de klasse hieronder erbij komt -
   ontbreekt dit script, dan blijft elke clip dus onzichtbaar en lijkt de
   film een reeks stilstaande posters. */
(function () {
  var clips = document.querySelectorAll('.terra-film__video');
  if (!clips.length) return;
  clips.forEach(function (v) {
    if (v.readyState >= 2) { v.classList.add('heeft-beeld'); return; }
    ['loadeddata', 'canplay', 'seeked'].forEach(function (soort) {
      v.addEventListener(soort, function () { v.classList.add('heeft-beeld'); }, { once: true });
    });
  });
})();

/* Alle filmclips alvast volledig binnenhalen, één voor één in shotvolgorde.
   De aandrijving warmt alleen het actieve shot en het volgende op; wie
   sneller scrolt dan de verbinding bijhoudt, komt dan in een clip terecht
   die nog laadt en ziet de overgang haperen. Het voorbeeldbestand had
   hier geen last van omdat alles daar al in het geheugen zat - dit haalt
   de winkel naar datzelfde punt. Na het laden zet één minieme seek de
   decoder op een scherp eerste frame: de allereerste echte seek toont
   anders eerst het grove tussenbeeld (zelfde verschijnsel als bij de
   scrub-banden beschreven). Wie een databundel spaart, slaan we over. */
(function () {
  if (window.__maziFilmWarm) return;
  window.__maziFilmWarm = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (navigator.connection && navigator.connection.saveData) return;

  function warm() {
    var clips = Array.prototype.slice.call(document.querySelectorAll('[data-film-clip]'));
    if (!clips.length) return;
    var i = 0;
    function volgende() {
      if (i >= clips.length) return;
      var v = clips[i++];
      var shot = v.closest('[data-film-shot]');
      var actief = shot && shot.classList.contains('is-active');
      if (v.readyState >= 4) {
        if (!actief) { try { if (v.currentTime === 0) v.currentTime = 0.001; } catch (e) {} }
        volgende();
        return;
      }
      var gedaan = false;
      var klaar = function () {
        if (gedaan) return;
        gedaan = true;
        v.removeEventListener('canplaythrough', klaar);
        if (!actief) { try { if (v.currentTime === 0) v.currentTime = 0.001; } catch (e) {} }
        volgende();
      };
      v.addEventListener('canplaythrough', klaar);
      v.preload = 'auto';
      /* Geen load(): dat reset het element, en de aandrijving kan er al
         mee bezig zijn. preload='auto' laat de browser gewoon doorladen. */
      setTimeout(klaar, 8000);   /* nooit op één trage clip blijven hangen */
    }
    volgende();
  }

  if (document.readyState === 'complete') { setTimeout(warm, 400); }
  else { window.addEventListener('load', function () { setTimeout(warm, 400); }); }
})();
